__turbopack_context__.v({
  "adv-slot": "index-module-scss-module__2fv5EG__adv-slot",
  "adv_user_profile_skyscraper": "index-module-scss-module__2fv5EG__adv_user_profile_skyscraper",
  "info-button": "index-module-scss-module__2fv5EG__info-button",
  "online": "index-module-scss-module__2fv5EG__online",
  "presence-indicator": "index-module-scss-module__2fv5EG__presence-indicator",
  "reply-icon": "index-module-scss-module__2fv5EG__reply-icon",
  "trust_info": "index-module-scss-module__2fv5EG__trust_info",
  "trust_info__active_since": "index-module-scss-module__2fv5EG__trust_info__active_since",
  "user-online-status": "index-module-scss-module__2fv5EG__user-online-status",
  "user-stats": "index-module-scss-module__2fv5EG__user-stats",
  "user-stats__button": "index-module-scss-module__2fv5EG__user-stats__button",
  "user-stats__button--hover": "index-module-scss-module__2fv5EG__user-stats__button--hover",
  "user-stats__counter": "index-module-scss-module__2fv5EG__user-stats__counter",
  "user-stats__label": "index-module-scss-module__2fv5EG__user-stats__label",
  "user_data_section": "index-module-scss-module__2fv5EG__user_data_section",
  "user_data_wrapper": "index-module-scss-module__2fv5EG__user_data_wrapper",
  "user_info": "index-module-scss-module__2fv5EG__user_info",
  "user_info--vertical-box": "index-module-scss-module__2fv5EG__user_info--vertical-box",
  "user_info__username": "index-module-scss-module__2fv5EG__user_info__username",
});
